import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';

import { DcrCellContentComponent } from './util/dcr-content/dcr-cell-content.component';

@NgModule({
	imports: [CommonModule, CwpNgFrameworkModule],
	declarations: [DcrCellContentComponent],
	exports: [DcrCellContentComponent]
})
export class DcrModule { }
